import * as React from "react";

const SvgEyeOn = (props) => (
  <svg
    width={23}
    height={23}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5 8.625c.779 0 1.453.285 2.021.854.57.569.854 1.242.854 2.021 0 .779-.284 1.453-.854 2.021-.569.57-1.242.854-2.021.854-.779 0-1.453-.284-2.021-.854-.57-.569-.854-1.242-.854-2.021 0-.779.285-1.453.854-2.021.569-.57 1.242-.854 2.021-.854Zm0 7.682c1.318 0 2.448-.472 3.392-1.415.943-.944 1.415-2.074 1.415-3.392s-.472-2.448-1.415-3.392c-.944-.943-2.074-1.415-3.392-1.415s-2.448.472-3.392 1.415c-.943.944-1.415 2.074-1.415 3.392s.472 2.448 1.415 3.392c.944.943 2.074 1.415 3.392 1.415Zm0-11.994c2.366 0 4.507.658 6.424 1.976 1.916 1.318 3.294 3.055 4.133 5.211-.839 2.156-2.216 3.893-4.133 5.21-1.917 1.319-4.058 1.977-6.424 1.977-2.366 0-4.507-.658-6.424-1.976C3.16 15.393 1.782 13.656.943 11.5c.839-2.156 2.217-3.893 4.133-5.21C6.993 4.97 9.134 4.311 11.5 4.311Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgEyeOn;
